module.exports = __webpack_public_path__ + "2f2dad03dc3b1144eb4fa0dc795bc8fc.svg";